"use client"

import { createContext, useContext, useState, ReactNode } from "react"

interface FeatureFlags {
  [key: string]: boolean
}

interface FeatureFlagContextType {
  featureFlags: FeatureFlags
  setFeatureFlags: (flags: FeatureFlags) => void
  isFeatureEnabled: (featureName: string) => boolean
}

const FeatureFlagContext = createContext<FeatureFlagContextType | null>(null)

export function FeatureFlagProvider({ children }: { children: ReactNode }) {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>({})

  const isFeatureEnabled = (featureName: string): boolean => {
    return featureFlags[featureName] || false
  }

  return (
    <FeatureFlagContext.Provider value={{ 
      featureFlags, 
      setFeatureFlags, 
      isFeatureEnabled 
    }}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

export function useFeatureFlags() {
  const context = useContext(FeatureFlagContext)
  if (!context) {
    throw new Error("useFeatureFlags must be used within a FeatureFlagProvider")
  }
  return context
} 